/**
 * @file AdminProfessionals.jsx — /cx/profesionales
 */
import React, { useState, useEffect, useCallback } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Search } from "lucide-react";
import { adminService } from "../services/admin";
import { ADMIN_STRINGS } from "../constants/strings";
import {
  Button,
  Card,
  Chip,
  Input,
  Spinner,
  Table,
  THead,
  TBody,
  TR,
  TH,
  TD,
} from "../ui";
import "./AdminGeneric.css";

export default function AdminProfessionals() {
  const [professionals, setProfessionals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = {};
      if (search.trim()) params.search = search.trim();
      const res = await adminService.getProfessionals(params);
      setProfessionals(res.data || []);
    } catch {
      // ignore
    } finally {
      setIsLoading(false);
    }
  }, [search]);

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line

  return (
    <div className="ag-page">
      <header className="ag-head">
        <span className="ag-eyebrow">Admin · Profesionales</span>
        <h1 className="ag-title">{ADMIN_STRINGS.PROFESSIONALS_TITLE}</h1>
      </header>

      <div className="ag-filters">
        <Input
          placeholder="Buscar por nombre..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && fetchData()}
          leftIcon={<Search size={14} />}
        />
        <Button onClick={fetchData}>Buscar</Button>
      </div>

      {isLoading ? (
        <div className="ag-loading">
          <Spinner size={28} />
        </div>
      ) : professionals.length === 0 ? (
        <Card className="ag-empty">
          <p>{ADMIN_STRINGS.PROFESSIONALS_EMPTY}</p>
        </Card>
      ) : (
        <>
          <p className="ag-count">
            {professionals.length} {professionals.length === 1 ? "resultado" : "resultados"}
          </p>
          <Card padded={false} className="ag-table-wrap">
            <Table>
              <THead>
                <TR>
                  <TH>Nombre</TH>
                  <TH>Especialidad</TH>
                  <TH>Onboarding</TH>
                  <TH>Cédulas</TH>
                  <TH>Ubicaciones</TH>
                  <TH>Citas</TH>
                  <TH>Estado</TH>
                </TR>
              </THead>
              <TBody>
                {professionals.map((p) => (
                  <TR key={p.id}>
                    <TD>
                      <RouterLink to={`/cx/usuario/${p.user.id}`} className="ag-link">
                        {p.user.firstName} {p.user.lastName}
                      </RouterLink>
                    </TD>
                    <TD>{p.specialty || "—"}</TD>
                    <TD>
                      <Chip tone={p.onboardingComplete ? "ok" : "warn"} size="sm">
                        {p.onboardingComplete ? "Completo" : `Paso ${p.onboardingStep}`}
                      </Chip>
                    </TD>
                    <TD>{p.specialties?.length || 0}</TD>
                    <TD>{p.locations?.length || 0}</TD>
                    <TD>{p._count?.appointments || 0}</TD>
                    <TD>
                      <Chip tone={p.user.isActive ? "ok" : "neutral"} size="sm">
                        {p.user.isActive ? "Activo" : "Inactivo"}
                      </Chip>
                    </TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          </Card>
        </>
      )}
    </div>
  );
}
